import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import Home from './Pages/Home';
import Login from './Pages/Login';
import NotFoundPage from './Pages/NotFoundPage';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/style.css';
import "react-datepicker/dist/react-datepicker.css";
import './scss/main.scss';
import Profile from './Pages/Profile';
import Settings from './Pages/Settings';
import Forgotpassword from './Pages/Forgotpassword';
import Resetpassword from './Pages/Resetpassword';
import Roles from './Pages/Roles';
import AddEditRole from './Pages/Roles/AddEdit';
import Dashboard from './Pages/Dashboard';
import History from './Pages/History';
import Signup from './Pages/Signup';
import Events from './Pages/Events';
import AddEditEvent from "./Pages/Events/AddEdit";
import ViewEvent from "./Pages/Events/View";
import Plan from "./Pages/Plan";
import ActivePlan from "./Pages/Plan/ActivePlan";
import AssignedEvents from './Pages/Events/AssignedEvents';
import AssignMembers from './Pages/AssignMembers';
import AddEditAssignMembers from './Pages/AssignMembers/AddEdit';
import Members from './Pages/Members';
import AddEdiMember from './Pages/Members/AddEdit';
import EventDetail from './Pages/EventDetail';
import Thanku from './Pages/Thanku';
import configureStoreProd from './Pages/config/configureStore.prod';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer, toast } from 'react-toastify';
import Setting from './Pages/Setting';
import Groups from './Pages/Groups';
import GroupRequest from './Pages/GroupRequest/GroupRequest';
import GroupRequestDetail from './Pages/GroupRequest/groupRequestDetail';
import PrivacyPolicy from './Pages/privacyPolicy';
import ContactUs from './Pages/Contact';
import TermCondition from './Pages/termCondition';
import AboutUs from './Pages/aboutUs';
import CheckIn from './Pages/CheckIn';
import EventCheckIn from './Pages/EventCheckIn';
import CmGuestRequest from './Pages/CmGuestRequest';
import RsvpConfirmation from './Pages/RsvpConfirmation';
import MyGroups from './Pages/MyGroups';
import AcceptInvite from './Pages/AcceptInvite';
import Testimonials from './Pages/Testimonials';
import TestimonialsIndividual from './Pages/TestimonialsIndividual';
import AlreadyConnected from './Pages/AlreadyConnected';
import Subscription from './Pages/Subscription';
import Install from './Pages/Install';
import Zoom from './Pages/Zoom';
import FindMember from './Pages/FindMember';
import AttendanceData from './Pages/AttendanceData';
import SsoCallback from './Pages/SsoCallback';
import BreakoutDetail from './Pages/BreakoutDetail';
import TroikaAssignments from './Pages/TroikaAssignments';
import RegistrationList from './Pages/RegistrationList';
// CM Scheduler
import CmSchedule from './Pages/CmSchedule';
import CmRate from './Pages/CmRate';
import CmPreferences from './Pages/CmPreferences';
import CmAnalytics from './Pages/CmAnalytics';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const { persistor, store } = configureStoreProd();

function App() {

  const routes=[
    {url:'',element:<Navigate to="/login" replace />},
    {url:'/login',element:<Login />},
    { url: '/rsvp-confirmation', element: <RsvpConfirmation /> },
    {url:'/signup',element:<Signup />},
    {url:'/dashboard',element:<Dashboard />},
    {url:'/profile',element:<Profile />},
    {url:'/user-profile/:id',element:<Profile />},
    {url:'/user-profile/:id/edit',element:<Settings />},
    {url:'/profile/:tab',element:<Settings />},
    {url:'/forgotpassword',element:<Forgotpassword />},
    {url:'/resetpassword',element:<Resetpassword />},
    {url:'/roles',element:<Roles />},
    {url:'/roles/add',element:<AddEditRole />},
    {url:'/roles/edit/:id',element:<AddEditRole />},
    {url:'/members/add',element:<AddEdiMember />},
    {url:'/members',element:<Members />}, 
    {url:'/setting',element:<Setting />}, 
    {url:'/my-groups',element:<MyGroups />},
    {url:'/history',element:<History />}, 
    {url:'/members/edit/:id',element:<AddEdiMember />},
    {url:'/assign-member/add',element:<AddEditAssignMembers />},
    {url:'/assign-member',element:<AssignMembers />},
    {url:'/assign-member/edit/:id',element:<AddEditAssignMembers />},
    {url:'/event',element:<Events />},
    // {url:'/connectMeetRequest',element:<GroupRequest/>},
    {url:'/event/edit/:eventid',element:<AddEditEvent />},
    {url:'/event/add',element:<AddEditEvent />},
    // {url:'/event/detail/:id',element:<ViewEvent />},
    {url:'/plan',element:<Plan />},
    {url:'/activeplan',element:<ActivePlan />},
    {url:'/assinged-event',element:<AssignedEvents />},
    {url:'/event/detail/:eventid',element:<EventDetail />},
    {url:'/thanku',element:<Thanku />},
    {url:'/groupsDetail/:eventid',element:<Groups/>},
    {url:'/troika-assignments/:eventid',element:<TroikaAssignments/>},
    {url:'/breakoutDetail/:eventid',element:<BreakoutDetail/>},
    // {url:'/connectMeetRequest/:eventid',element:<GroupRequestDetail/>},
    {url:'/privacyPolicy',element:<PrivacyPolicy/>},
    {url:'/contactUs',element:<ContactUs/>},
    {url:'/termCondition',element:<TermCondition/>},
    {url:'/aboutUs',element:<AboutUs/>},
    {url:'/checkin/:eventid',element:<CheckIn />},
    // Login-free QR check-in (email + short event code); public, no auth.
    {url:'/event-checkin',element:<EventCheckIn />},
    {url:'/cm-request',element:<CmGuestRequest />},
    {url:'/accept-invite',element:<AcceptInvite />},
    {url:'/testimonials',element:<Testimonials />},
    {url:'/testimonials-individual',element:<TestimonialsIndividual />},
    {url:'/already-connected',element:<AlreadyConnected />},
    {url:'/subscription',element:<Subscription />},
    {url:'/install',element:<Install />},
    {url:'/zoom',element:<Zoom />},
    {url:'/find-member',element:<FindMember />},
    {url:'/attendance-data',element:<AttendanceData />},
    {url:'/sso-callback',element:<SsoCallback />},
    // Registration List — shareable "Who's coming" photolist (encrypted eventid)
    {url:'/registration-list/:eventid',element:<RegistrationList />},
    // CM Scheduler
    {url:'/cm-schedule',element:<CmSchedule />},
    {url:'/cm-rate',element:<CmRate />},
    {url:'/cm-preferences',element:<CmPreferences />},
    {url:'/cm-analytics',element:<CmAnalytics />},
    {url:'*',element:<NotFoundPage />}
  ]

  
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
    {clerkPubKey ? (
      <ClerkProvider publishableKey={clerkPubKey}>
        <Router>
          <Routes>
            {routes.map(itm=>{
              return <Route path={itm.url} element={itm.element} />
            })}
          </Routes>
        </Router>
      </ClerkProvider>
    ) : (
      <Router>
        <Routes>
          {routes.map(itm=>{
            return <Route path={itm.url} element={itm.element} />
          })}
        </Routes>
      </Router>
    )}
    </PersistGate>
    </Provider>
     <div id="loader" className="loaderDiv d-none">
            <div>
                <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
            </div>
        </div>
        <ToastContainer position="top-right" stacked closeOnClick={false} closeButton={({ closeToast }) => (
          <button onClick={(e) => { e.stopPropagation(); toast.dismiss(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', padding: '4px' }}>✕</button>
        )} />
    </>
    
  );
}

export default App;
